import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';

// Firebase credentials for Meal Bee
const firebaseConfig = {
  apiKey: "AIzaSyAYJ3SVhprMz7RD7aw-qmoZQKNHkSmxRzs",
  authDomain: "meal-bee-c2767.firebaseapp.com",
  projectId: "meal-bee-c2767",
  storageBucket: "meal-bee-c2767.firebasestorage.app",
  messagingSenderId: "80220646652",
  appId: "1:80220646652:web:dcbfbe12f93c24c96bbb79",
  measurementId: "G-LBGGHL56H5"
};

// Initialize Firebase Core Apps
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Safely initialize Web Messaging only when running in a standard web browser environment
export let messaging = null;
if (!Capacitor.isNativePlatform()) {
    try {
        messaging = getMessaging(app);
    } catch (error) {
        console.log("Firebase Web Messaging not supported or initialization failed:", error);
    }
}

/**
 * Requests push notification permissions and fetches the FCM token
 * Routes natively on iOS/Android, and utilizes standard Web Push on browsers
 */
export const requestNotificationPermission = async () => {
    try {
        // ---------------------------------------------------------
        // PATH A: NATIVE ANDROID/iOS APP
        // ---------------------------------------------------------
        if (Capacitor.isNativePlatform()) {
            console.log("Requesting Native Push Permissions...");
            
            let permStatus = await PushNotifications.checkPermissions();
            if (permStatus.receive === 'prompt') {
                permStatus = await PushNotifications.requestPermissions();
            }

            if (permStatus.receive !== 'granted') {
                console.log("Native Notification permission denied");
                return null;
            }

            // Register device with APNS/FCM network
            await PushNotifications.register();

            // Native tokens are asynchronously received via event listeners
            return new Promise((resolve) => {
                PushNotifications.addListener('registration', (token) => {
                    console.log("Native FCM Token:", token.value);
                    resolve(token.value);
                });

                PushNotifications.addListener('registrationError', (error) => {
                    console.log("Native Registration Error:", error);
                    resolve(null);
                });
            });
        } 
        
        // ---------------------------------------------------------
        // PATH B: WEB BROWSER
        // ---------------------------------------------------------
        else {
            console.log("Requesting Web Push Notifications...");
            
            if (!('Notification' in window)) {
                console.log("Web Notifications are not supported on this browser.");
                return null;
            }

            const permission = await Notification.requestPermission();
            if (permission !== "granted") {
                console.log("Web Notification permission denied");
                return null;
            }

            if (!messaging) {
                console.log("Messaging instance uninitialized.");
                return null;
            }

            const token = await getToken(messaging, {
                vapidKey: "BEbWgRD-RkR7iKXxSMw2W6iGVptYnF-Kv8lomepuV9bjXFkJQ-msWDQVpyBIv514vWyrtgqw-gipfQDq5f4kcio"  
            });
            console.log("Web FCM Token:", token);
            return token;
        }

    } catch (error) {
        console.log("FCM Token Retrieval Error:", error);
        return null;
    }
};

/**
 * Sets up a listener to handle incoming notifications when the app is actively open
 */
export const onForegroundMessage = (callback) => {
    if (Capacitor.isNativePlatform()) {
        // Native foreground notification receiver
        PushNotifications.addListener('pushNotificationReceived', (notification) => {
            console.log("Native Foreground message received:", notification);
            callback(notification);
        });
    } else {
        // Web browser foreground notification receiver
        if (!messaging) return;
        onMessage(messaging, (payload) => {
            console.log("Web Foreground message received:", payload);
            callback(payload);
        });
    }
};